"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Cls1 = _styledComponents["default"].circle.withConfig({
  displayName: "Analysis__Cls1",
  componentId: "kzzqf7-0"
})(["fill:#4993cf;fill-opacity:0.2;"]);

var Cls2Rect = _styledComponents["default"].rect.withConfig({
  displayName: "Analysis__Cls2Rect",
  componentId: "kzzqf7-1"
})(["fill:#fff;"]);

var Cls2Polygon = _styledComponents["default"].polygon.withConfig({
  displayName: "Analysis__Cls2Polygon",
  componentId: "kzzqf7-2"
})(["fill:#fff;"]);

var Cls2Circle = _styledComponents["default"].circle.withConfig({
  displayName: "Analysis__Cls2Circle",
  componentId: "kzzqf7-3"
})(["fill:#fff;"]);

var Cls3 = _styledComponents["default"].path.withConfig({
  displayName: "Analysis__Cls3",
  componentId: "kzzqf7-4"
})(["fill:none;stroke:#1c7dc1;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;opacity:0.4;"]);

var Cls4Rect = _styledComponents["default"].rect.withConfig({
  displayName: "Analysis__Cls4Rect",
  componentId: "kzzqf7-5"
})(["fill:#1c7dc1;opacity:0.4;"]);

var Cls4Line = _styledComponents["default"].line.withConfig({
  displayName: "Analysis__Cls4Line",
  componentId: "kzzqf7-6"
})(["fill:#1c7dc1;opacity:0.4;"]);

var Cls5 = _styledComponents["default"].path.withConfig({
  displayName: "Analysis__Cls5",
  componentId: "kzzqf7-7"
})(["fill:#4993cf;"]);

var Cls6 = _styledComponents["default"].g.withConfig({
  displayName: "Analysis__Cls6",
  componentId: "kzzqf7-8"
})(["fill:#11cc6e;left:80%;"]);

var Analysis = function Analysis(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    width: "52",
    height: "52",
    viewBox: "0 0 564 564",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement(Cls1, {
    cx: "282",
    cy: "282",
    r: "282"
  }), _react["default"].createElement(Cls2Rect, {
    x: "129",
    y: "98",
    width: "278",
    height: "365"
  }), _react["default"].createElement(Cls3, {
    d: "M173.34,139.2c1.65-4.86,2.84-4.62,4.18-7.44,1-2.11,1.68-4.7-.14-6.53a2.66,2.66,0,0, 0-3.25-.62,2.54,2.54,0,0,0-.63,3.23,4.1,4.1,0,0,0,3.32,1.91,12.46,12.46,0,0,0,3.62.08c3.14-.62,6.23-1.84, 9.48-1.27,4.89.86,9.15,3.74,14.26,3.56a16.06,16.06,0,0,0,7.16-2c1-.52,1.93-1.58,1.38-2.75a3.94,3.94,0,0, 0-1.68-1.41q-1.17-.72-2.36-1.4A60.57,60.57,0,0,0,195,118.75c-1.43-.4-3.57-1-4.84.13a2.16,2.16,0,0,0-.44,3, 5.82,5.82,0,0,0,2.81,1.82c4.78,1.87,10.19,2.26,15.26,2.73l3.63.33a18.34,18.34,0,0,0, 3.2.22c1.47-.13.91-1.28.39-2.18a37.17,37.17,0,0,0-2.55-3.88,24.05,24.05,0,0, 0-6.63-6.25c-1.87-1.11-5.33-2.64-6.94-.31s1.79,4,3.46,4.66c2.94,1.19,5.94,2.13,8.81,3.49a51.44,51.44,0,0,1,8.34, 4.9,40.68,40.68,0,0,1,3.64,3c1.1,1,2.42,2.17,2.81,3.68a2.57,2.57,0,0,1-1.49, 3.21c-1.34.45-2.75-.12-4.1-.22-1.12-.08-2.85.15-3.08,1.53-.29,1.73,2.72,1.35,3.68,1.21a24.24,24.24,0,0,1,5-.66, 6.7,6.7,0,0,1,4.06,1.7c2,1.81,2.22,5.22-.77,6.06-2.74.78-4.9-1.35-7.4-2-3-.81-5.3.86-7.77,2.36a6.11,6.11,0,0, 1-3.88.88c-1.64-.21-2.34-1.25-3.43-2.32a13.07,13.07,0,0,0-6.91-3.4,16.21,16.21,0,0,0-7.22.41c-2.13.61-2, 1.72-3.69,3.13a21.65,21.65,0,0,1-8.41,3.66,10.19,10.19,0,0,1-4.33-.59c-1.67-.49-3.32-1-5-1.48a12.66,12.66,0,0, 0-9.43.73c-2.81,1.43-5.19,3.55-7.84,5.22a16.7,16.7,0,0,1-4.46,2.1c-1.15.31-3.37.76-4.38-.11s-.09-2.27.76-3a12.79, 12.79,0,0,1,3.58-1.8,33.22,33.22,0,0,0,8.18-4.33,35.15,35.15,0,0,0,3.58-3.06,17.87,17.87,0,0,1,3.36-2.79,6.71, 6.71,0,0,1,3.87-.89,10.42,10.42,0,0,1,3.33,1.25"
  }), _react["default"].createElement(Cls2Polygon, {
    points: "330 130 442 241 442 501 162 501 162 130 330 130"
  }), _react["default"].createElement(Cls4Line, {
    x1: "386.18",
    y1: "280.5",
    x2: "191.45",
    y2: "280.5"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "265.8",
    width: "221.55",
    height: "9.79",
    rx: "2.09",
    ry: "2.09"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "303.24",
    width: "221.55",
    height: "10",
    rx: "2.11",
    ry: "2.11"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "340.79",
    width: "221.55",
    height: "10",
    rx: "2.11",
    ry: "2.11"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "378.33",
    width: "221.55",
    height: "10",
    rx: "2.11",
    ry: "2.11"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "415.88",
    width: "221.55",
    height: "10",
    rx: "2.11",
    ry: "2.11"
  }), _react["default"].createElement(Cls4Rect, {
    x: "189.45",
    y: "453.43",
    width: "221.55",
    height: "10",
    rx: "2.11",
    ry: "2.11"
  }), _react["default"].createElement(Cls4Line, {
    x1: "191.45",
    y1: "433.07",
    x2: "386.18",
    y2: "433.07"
  }), _react["default"].createElement(Cls2Polygon, {
    points: "332 144 332 241 436 241 332 140 332 144"
  }), _react["default"].createElement(Cls2Circle, {
    cx: "344",
    cy: "406",
    r: "76"
  }), _react["default"].createElement(Cls5, {
    d: "M480.67,529.83c-4.8-4.81-9.89-9.37-14.3-14.52-1.29-1.5-35.55-36.38-52.4-53.28,5.39-12.88, 12.57-25.47,16-39,11.53-45.76-18.62-92-66.4-103.73-43.85-10.76-91.78,18-103.13,61.85-15.29,59.11,28.29,113.46, 89.23,111,18-.73,34-7.14,48.41-18,1.12-.84,3.83-1.4,4.49-.75,17.8,17.52,52.46,52,52.83,52.37,7,6.05,13.52,12.55, 20.24,18.88l4.1.18C486.46,539.68,486.72,535.9, 480.67,529.83Zm-136-52.53c-40.07-.07-72.92-33.09-72.68-73.05s33.08-72.59,72.86-72.48a73.19,73.19,0,0,1,72.72, 72.66C417.71,444.37,384.71,477.37,344.69,477.3Z"
  }), _react["default"].createElement(Cls5, {
    d: "M424,494c-85.7,0-171.24,0-256.06,0V139h4.54c48.59,0,97.17.05,145.76-.1,4.06,0,4.93, 1.16,4.92,5-.15,33.69,0,67.38-.2,101.08,0,4.33,1.25,5.17,5.32,5.15q50.75-.25,101.51.06c1.46,0,4.17,2.29,4.18, 3.52q.3,112.39.17,224.78v1.66c0,.7-.1,2.35-.14,2.84,5.12,5.1,11.32,10.29,15, 16-.3-1-.12-5.23-.12-6.19-.18-83.29-.12-166.57-.27-249.86a11.54,11.54,0,0, 0-2.78-6.91c-10.07-10.45-20.56-20.51-30.61-31a12.49,12.49,0,0, 1-3.26-7.79c-.21-35.14-.14-70.27-.14-105.41v-5a10.11,10.11,0,0,0-1.74-.41q-145.75,0-291.5.11c-1,0-3,2.27-3, 3.48q-.21,188.91,0,377.82c0,1.23,2.47,3.48,3.84,3.53,9.68.31,19.38,0,29.05.34,1.41,0,3.86,2.43,3.92,3.8.35,9.1.44, 18.22.08,27.32-.18,4.47,1,5.74,5.6,5.73q137.73-.22,275.45,0c1.32,0,5-.17,6.42.41A87.19,87.19,0,0,1,424, 494Zm-1.44-259.38a25,25,0,0,1-3,.35c-25.85,0-51.7.05-77.55-.09-1.34,0-3.83-1.48-3.83-2.28C338,205.22,338, 177.83,338,150ZM157.22,123.82c-4.06,0-4.92,1.17-4.92,5q.16,161.38.2,322.76c0,4.66-1.31,5.68-5.75, 5.62-16.65-.25-16.66-.09-16.66-16.77q0-166.58-.1-333.17c0-4.38.84-5.78,5.56-5.77q128,.24,255.95,0c4.17,0,5.29,1, 5.26,5.21-.21,25-.1,50-.1,75v5.7c-20.9-20.95-40.65-40.84-60.6-60.54a11.72,11.72,0,0,0-7.11-2.93C271.7,123.89, 214.46,124,157.22,123.82Z"
  }), _react["default"].createElement(Cls3, {
    d: "M207.34,185.2c1.65-4.86,2.84-4.62,4.18-7.44,1-2.11,1.68-4.7-.14-6.53a2.66,2.66,0,0, 0-3.25-.62,2.54,2.54,0,0,0-.63,3.23,4.1,4.1,0,0,0,3.32,1.91,12.46,12.46,0,0,0,3.62.08c3.14-.62,6.23-1.84, 9.48-1.27,4.89.86,9.15,3.74,14.26,3.56a16.06,16.06,0,0,0,7.16-2c1-.52,1.93-1.58,1.38-2.75a3.94,3.94,0,0, 0-1.68-1.41q-1.17-.72-2.36-1.4A60.57,60.57,0,0,0,229,164.75c-1.43-.4-3.57-1-4.84.13a2.16,2.16,0,0,0-.44,3, 5.82,5.82,0,0,0,2.81,1.82c4.78,1.87,10.19,2.26,15.26,2.73l3.63.33a18.34,18.34,0,0,0, 3.2.22c1.47-.13.91-1.28.39-2.18a37.17,37.17,0,0,0-2.55-3.88,24.05,24.05,0,0, 0-6.63-6.25c-1.87-1.11-5.33-2.64-6.94-.31s1.79,4,3.46,4.66c2.94,1.19,5.94,2.13,8.81,3.49a51.44,51.44,0,0,1,8.34, 4.9,40.68,40.68,0,0,1,3.64,3c1.1,1,2.42,2.17,2.81,3.68a2.57,2.57,0,0,1-1.49, 3.21c-1.34.45-2.75-.12-4.1-.22-1.12-.08-2.85.15-3.08,1.53-.29,1.73,2.72,1.35,3.68,1.21a24.24,24.24,0,0,1,5-.66, 6.7,6.7,0,0,1,4.06,1.7c2,1.81,2.22,5.22-.77,6.06-2.74.78-4.9-1.35-7.4-2-3-.81-5.3.86-7.77,2.36a6.11,6.11,0,0, 1-3.88.88c-1.64-.21-2.34-1.25-3.43-2.32a13.07,13.07,0,0,0-6.91-3.4,16.21,16.21,0,0,0-7.22.41c-2.13.61-2,1.72-3.69, 3.13a21.65,21.65,0,0,1-8.41,3.66,10.19,10.19,0,0,1-4.33-.59c-1.67-.49-3.32-1-5-1.48a12.66,12.66,0,0, 0-9.43.73c-2.81,1.43-5.19,3.55-7.84,5.22a16.7,16.7,0,0,1-4.46,2.1c-1.15.31-3.37.76-4.38-.11s-.09-2.27.76-3a12.79, 12.79,0,0,1,3.58-1.8,33.22,33.22,0,0,0,8.18-4.33,35.15,35.15,0,0,0,3.58-3.06,17.87,17.87,0,0,1,3.36-2.79,6.71, 6.71,0,0,1,3.87-.89,10.42,10.42,0,0,1,3.33,1.25"
  }), _react["default"].createElement(Cls6, {
    transform: "scale(0.055) translate(5350, 6450)"
  }, _react["default"].createElement("path", {
    d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68  28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
  })), _react["default"].createElement(Cls5, {
    d: "M423,494"
  }));
};

Analysis.displayName = 'Analysis';
Analysis.propTypes = {
  className: _propTypes["default"].string
};
Analysis.defaultProps = {
  className: ''
};
var _default = Analysis;
exports["default"] = _default;